import React, { useEffect, useState } from 'react'
import { FaPlus, FaEdit, FaEye } from 'react-icons/fa'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { Table, Form, message, Input, Select, Tooltip } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { CustomSelect, Inputs, DeleteModal, CustomModal, SearchOrganizations, SearchOrganizationsParking } from '../../Components'
import { GET, POST } from '../../utils/apis'
import { secureApi } from '../../Config/api'
import { fetchAllOrganization, verifyToken } from '../../utils/helpers'
import { DatabaseZap, Search, Building2 } from 'lucide-react'
import { translations, pageSizeOptions, allPaths } from '../../utils/constants'
import { setOrganizationFilter } from '../../Redux/actions/organizationActions'
import { setUserFilter } from '../../Redux/actions/filterUsersAction'

const ManageParkinglots = ({ language }) => {
    const organizationFromRedux = useSelector((state) => state.organizationReducer?.allOrganizations)
    const authUser = useSelector(state => state?.authReducer?.user)
    const organizationDetails = useSelector(state => state?.authReducer?.organization)
    const organizationFilter = useSelector(state => state.organizationReducer.organizationFilter)
    const organizationCount = useSelector(state => state.organizationReducer?.orgSelectionCount || 0)
    const userFilterRedux = useSelector(state => state?.filterUsersReducer?.userFilter)
    const history = useHistory()
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [editlotForm] = Form.useForm()
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [addlotLoading, setAddLotLoading] = useState(false)
    const [viewModal, setViewModal] = useState(false)
    const [selectedlot, setSelectedlot] = useState(null)
    const [editModal, setEditModal] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [lotToDelete, setlotToDelete] = useState(null)
    const [lotToEdit, setlotToEdit] = useState(null)
    const [editDataLoading, setEditDataLoading] = useState(false)
    const [displayedlots, setDisplayedlots] = useState([])
    const [organizations, setOrganizations] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [searchModal, setSearchModal] = useState(false)
    const [initialLoading, setInitialLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalItems, setTotalItems] = useState(0)

    useEffect(() => {
        verifyToken(history, dispatch)
        fetchAllOrganization({ dispatch })
        setOrganizations(organizationFromRedux || [])
    }, [])

    useEffect(() => {
        fetchParkingLots()
    }, [currentPage, pageSize, searchQuery, organizationFilter])

    const fetchParkingLots = async () => {
        setLoading(true)
        try {
            const params = {
                search: searchQuery,
                page: currentPage,
                limit: pageSize,
                organization_filter: organizationFilter,
                organizationId: organizationDetails?.id,
                role: authUser?.role
            }
            // console.log(organizationDetails?.id, 'org id')

            const response = await secureApi?.get(GET?.GET_PARKING_LOT, { params })
            console.log(response, 'respnse')
            if (response?.success) {
                setDisplayedlots(response?.data?.records || [])
                setTotalItems(response?.data?.pagination?.totalRecords || 0)
            } else {
                message.error(response?.message || 'Failed to fetch parking lots.')
            }
        } catch (error) {
            message.error('Error fetching parking lots.')
        } finally {
            setLoading(false)
        }
    }

    const handleSearch = (query) => {
        setSearchQuery(query)
    }

    const showModal = async () => {
        const isTokenValid = await verifyToken(history, dispatch)
        if (!isTokenValid) {
            message.error('Session expired. Please log in again.')
            return
        }
        setIsModalVisible(true)
        if (organizationDetails?.id) {
            form.setFieldsValue({
                organization: organizationDetails.id
            });
        }
    }

    const showSearchModal = () => {
        setSearchModal(!searchModal)
    }

    const viewDetails = (record) => {
        setSelectedlot(record)
        setViewModal(true)
    }

    const closeDetails = () => {
        setViewModal(false)
        setSelectedlot(null)
    }

    const closeEditModal = () => {
        editlotForm.resetFields()
        setEditModal(false)
    }

    const handleClose = () => {
        form.resetFields()
        setIsModalVisible(false)
    }

    const handleAction = async () => {
        const isTokenValid = await verifyToken(history, dispatch);
        if (!isTokenValid) {
            message.error('Session expired. Please log in again.');
            return;
        }

        let values
        try {
            values = await form.validateFields()
        } catch (validationError) {
            return
        }

        setAddLotLoading(true)
        try {
            const response = await secureApi.post(POST?.ADD_PARKING_LOT, {
                lot_name: values?.name,
                address: values?.address,
                total_spaces: values?.totalSpaces,
                organization_id: values?.organization,
            })

            if (response.success === true) {
                message.success('Parking lot added successfully!')
                fetchParkingLots()
                form.resetFields()
                setIsModalVisible(false)
            } else {
                message.error(response?.error || response?.message)
            }
        } catch (error) {
            message.error('Failed to add parking lot. Please try again.')
        } finally {
            setAddLotLoading(false)
        }
    }

    const handleUpdatelot = async () => {
        const isTokenValid = await verifyToken(history, dispatch)
        if (!isTokenValid) {
            message.error('Session expired. Please log in again.')
            return
        }

        let values
        try {
            values = await editlotForm.validateFields()
        } catch (validationError) {
            return
        }

        setEditDataLoading(true)
        try {
            const response = await secureApi.post(POST?.EDIT_PARKING_LOT, {
                id: lotToEdit?.id,
                lot_name: values?.name,
                address: values?.address,
                total_spaces: values?.totalSpaces,
            })
            if (response?.success === true) {
                message.success('Parking lot updated successfully!')
                fetchParkingLots()
                editlotForm.resetFields()
                setEditModal(false)
            } else {
                message.error(response?.error || response?.message)
            }
        } catch (error) {
            message.error('Network error or something went wrong.')
        } finally {
            setEditDataLoading(false)
        }
    }

    const handleEdit = async (record) => {
        const isTokenValid = await verifyToken(history, dispatch)
        if (!isTokenValid) {
            message.error('Session expired. Please log in again.')
            return
        }

        setEditModal(true)
        setViewModal(false)
        setlotToEdit(record)

        editlotForm.setFieldsValue({
            name: record?.lot_name,
            address: record?.address,
            totalSpaces: record?.total_spaces,
            organization: record?.organization_id
        })
    }

    const handleDelete = (record) => {
        setDeleteModal(true)
        setlotToDelete(record)
    }

    const handleCancel = () => {
        setDeleteModal(false)
        setlotToDelete(null)
    }

    const handleConfirmDelete = async () => {
        const isTokenValid = await verifyToken(history, dispatch)
        if (!isTokenValid) {
            message.error('Session expired. Please log in again.')
            return
        }

        setDeleteModal(false)
        setLoading(true)

        if (lotToDelete) {
            try {
                const response = await secureApi.post(POST?.DELETE_PARKING_LOT, {
                    id: lotToDelete.id,
                })
                if (response?.success === true) {
                    fetchParkingLots()
                    message.success(`${lotToDelete?.lot_name} deleted successfully.`)
                } else {
                    message.error(response?.error || response?.message)
                }
            } catch (error) {
                message.error('Failed to delete parking lot. Please try again.')
            } finally {
                setLoading(false)
            }
        }
        setlotToDelete(null)
    }

    const handleOrganizationChange = (value) => {
        dispatch(setOrganizationFilter(value))
        dispatch(setUserFilter(value))
    }

    const columns = [
        {
            title: translations[language]?.parkinglotName || 'lot Name',
            dataIndex: 'lot_name',
            key: 'lot_name',
            render: (text, record) => {
                const capitalizedText = text ? text.charAt(0).toUpperCase() + text.slice(1) : ''
                return (
                    <div className='vl-name-cell' onClick={() => {
                        const url = `${allPaths?.PARKING_SLOTS}/${record?.organization_id}`;
                        window.open(url, '_blank', 'noopener,noreferrer');
                    }}>
                        <span className='vl-avatar'>{(capitalizedText || '-').slice(0, 2).toUpperCase()}</span>
                        <span className='vl-name-text'>{capitalizedText || '-'}</span>
                        <FaEye className='vl-name-view' />
                    </div>
                )
            }
        },
        {
            title: translations[language]?.address || 'Address',
            dataIndex: 'address',
            key: 'address',
            render: (text) => text ? <span>{text}</span> : <span className='vl-muted'>-</span>
        },
        {
            title: translations[language]?.organization || 'organization',
            dataIndex: 'organization_name',
            key: 'organization_name',
            render: (text) => text ? <span className='capitalized-name' style={{ whiteSpace: 'nowrap' }}>{text}</span> : <span className='vl-muted'>-</span>
        },
        {
            title: translations[language]?.totalSpaces || 'Total Spaces',
            dataIndex: 'total_spaces',
            key: 'total_spaces',
            align: 'center',
            render: (text) => (text === null || text === undefined || text === '') ? <span className='vl-muted'>-</span> : <span className='vl-count-chip'>{Number(text).toLocaleString()}</span>
        },
        {
            title: translations[language]?.action,
            key: 'action',
            render: (_, record) => {
                return (
                    <div className='vl-actions'>
                        <Tooltip title={translations[language]?.parkinglotName || 'Open'}>
                            <button
                                type='button'
                                className='vl-action-btn vl-action-view'
                                onClick={() => window.open(`${allPaths?.PARKING_SLOTS}/${record?.organization_id}`, '_blank', 'noopener,noreferrer')}
                            >
                                <FaEye size={14} />
                            </button>
                        </Tooltip>
                        <Tooltip title={translations[language]?.editlotText || 'Edit lot'}>
                            <button
                                type='button'
                                className='vl-action-btn vl-action-edit'
                                onClick={() => handleEdit(record)}
                            >
                                <FaEdit size={14} />
                            </button>
                        </Tooltip>
                        <Tooltip title={translations[language]?.deletelot || 'Delete Parking lot'}>
                            <button
                                type='button'
                                className='vl-action-btn vl-action-delete'
                                onClick={() => handleDelete(record)}
                            >
                                <RiDeleteBin6Line size={14} />
                            </button>
                        </Tooltip>
                    </div>
                )
            }
        }
    ]

    return (
        <div className='main-container'>
            <div className='main-inner-container'>
                <h1 className='main-heading'>{translations[language]?.parkinglotsHeading || 'Parking lots'}</h1>
                <div className='insider-container'>
                    <div className='insider-container-buttons'>
                        <div>
                            {authUser?.role === 'superAdmin' ?
                                <button type="button" className='add-button' onClick={showModal}>
                                    <FaPlus className='icon' />
                                    {translations[language]?.addlotButton || 'Add Parking lot'}
                                </button>
                                :
                                null
                            }
                        </div>
                        {authUser?.role === 'superAdmin' ? <div className='get-reports-container'>
                            <div className='search-main-div'>
                                <div className="search-inner-div">
                                    <Search className="search-icon" />
                                    <input
                                        placeholder={translations[language]?.searchlots || 'Search Parking lots...'}
                                        value={searchQuery}
                                        onChange={(e) => handleSearch(e.target.value)}
                                        className="search-input"
                                    />
                                    {searchQuery && (
                                        <span className="clear-icon" style={{ cursor: "pointer" }} onClick={() => handleSearch("")}>
                                            ✕
                                        </span>
                                    )}
                                </div>
                                <span type='primary'
                                    className={`organization ${searchModal ? 'open-organization' : 'close-organization'}`}
                                    onClick={showSearchModal}
                                >
                                    <Building2 />
                                    {translations[language]?.organizations}
                                    {organizationCount ? <div className="filter-count-badge">
                                        {organizationCount}
                                    </div> : null}
                                </span>
                            </div>
                        </div>
                            :
                            null
                        }
                    </div>

                    <div className='vd-card'>
                        {displayedlots?.length === 0 ? (
                            <div className='vd-card-body'>
                                <div className="no-vehicles-container">
                                    <div className="no-vehicles-text-center">
                                        <div className="flex-col-center">
                                            <div className="no-vehicles-text-center">
                                                <DatabaseZap className='no-vehicle-icon' />
                                                <h3 className="no-vehicles-heading">{translations[language]?.nolotsFound || 'No Parking lots Found'}</h3>
                                                {authUser?.role === 'superAdmin' ?
                                                    <>
                                                        <p className="no-vehicles-description">
                                                            {translations[language]?.addlotToSeeList || 'Add a parking lot to see it here.'}
                                                        </p>
                                                        <div>
                                                            <button type="button" className='add-button' onClick={showModal}>
                                                                <FaPlus className='icon' />
                                                                {translations[language]?.addlotButton || 'Add Parking lot'}
                                                            </button>
                                                        </div>
                                                    </>
                                                    :
                                                    null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className='vd-card-header'>
                                    <div className='vl-list-title'>
                                        <h2 className='vd-card-title'>{translations?.[language]?.parkinglotList || 'Parking lots List'}</h2>
                                        <span className='vl-total-chip'>{translations[language]?.totalRecord}: <strong>{totalItems}</strong></span>
                                    </div>
                                </div>
                                <div className='vd-card-body'>
                                    <Table
                                        className='vl-table'
                                        dataSource={displayedlots}
                                        columns={columns}
                                        rowKey="id"
                                        pagination={{
                                            current: currentPage,
                                            pageSize: pageSize,
                                            total: totalItems,
                                            showSizeChanger: true,
                                            showQuickJumper: true,
                                            pageSizeOptions,
                                            onChange: (page, size) => {
                                                setCurrentPage(page)
                                                setPageSize(size)
                                            },
                                        }}
                                        scroll={{ x: 300 }}
                                        loading={loading}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <CustomModal
                isVisible={isModalVisible}
                onClose={handleClose}
                title={translations[language]?.addlotButton || 'Add Parking lot'}
                actionText={translations[language]?.addlotButton || 'Add Parking lot'}
                onAction={handleAction}
                loading={addlotLoading}
                language={language}
            >
                <Form form={form} layout='vertical' className='pl-form'>
                    <div className='ps-section-head pl-form-head'>
                        <h3>{translations[language]?.lotDetailsHeading || 'Parking lot Details'}</h3>
                    </div>
                    <Inputs
                        label={translations[language]?.parkinglotName || 'Parking lot Name'}
                        placeholder={translations[language]?.enterlotName || 'Enter lot name'}
                        name='name'
                        rules={[{ required: true, message: translations[language]?.pleaseEnterParkingLotName || 'Please enter parking lot name' }]}
                    />
                    <Inputs
                        label={translations[language]?.address || 'Address'}
                        placeholder={translations[language]?.enterAddress || 'Enter address'}
                        name='address'
                        rules={[{ required: true, message: translations[language]?.pleaseEnterAddress || 'Please enter address' }]}
                    />
                    <Inputs
                        label={translations[language]?.totalSpaces || 'Total Spaces'}
                        placeholder={translations[language]?.enterTotalSpaces || 'Enter total spaces'}
                        name='totalSpaces'
                        type='number'
                        max={100000}
                        min={1}
                        rules={[
                            { required: true, message: translations[language]?.pleaseEnterTotalSpaces || 'Please enter total number of spaces' },
                            {
                                validator: (_, value) => {
                                    if (value === undefined || value === '') return Promise.resolve();
                                    const num = Number(value);
                                    if (isNaN(num)) return Promise.reject(translations[language]?.pleaseEnterValidNumber || 'Please enter a valid number');
                                    if (num < 1) return Promise.reject(translations[language]?.totalSpacesAtLeast1 || 'Total spaces must be at least 1');
                                    if (num > 100000) return Promise.reject(translations[language]?.totalSpacesMax || 'Total spaces cannot exceed 100000');
                                    if (!Number.isInteger(num)) return Promise.reject(translations[language]?.totalSpacesWholeNumber || 'Total spaces must be a whole number');
                                    return Promise.resolve();
                                }
                            }
                        ]}
                    />
                    <div>
                        <CustomSelect
                            label={translations[language]?.organizations || 'Organization'}
                            placeholder={translations[language]?.organizationSelect || 'Select organization'}
                            name="organization"
                            filterOption={(input, option) =>
                                String(option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={
                                organizationDetails?.id
                                    ? [{ label: organizationDetails?.name, value: organizationDetails?.id }]
                                    : organizations?.map(org => ({
                                        label: org?.organization_name,
                                        value: org?.id
                                    }))
                            }
                            disabled={!!organizationDetails?.id}
                            rules={[{ required: true, message: translations[language]?.pleaseSelectOrganization || 'Please select an organization' }]}
                        />
                    </div>
                </Form>
            </CustomModal>

            <CustomModal
                isVisible={viewModal}
                onClose={closeDetails}
                title={translations[language]?.lotDetailsHeading || 'Parking lot Details'}
                actionText={translations[language]?.editlotText || 'Edit lot'}
                onAction={() => handleEdit(selectedlot)}
                language={language}
            >
                <div className='device-information-section'>
                    <div className='inner-information-div'>
                        <div className='info-childern-div'>
                            <div className='inner-information-childern'>
                                <h3 className='info-heading'>{translations[language]?.parkinglotName || 'lot Name'}</h3>
                                <p>{selectedlot?.lot_name}</p>
                            </div>
                        </div>
                        <div className='info-childern-div'>
                            <div className='inner-information-childern'>
                                <h3 className='info-heading'>{translations[language]?.address || 'Address'}</h3>
                                <p>{selectedlot?.address}</p>
                            </div>
                        </div>
                    </div>
                    <div className='inner-information-div'>
                        <div className='info-childern-div'>
                            <div className='inner-information-childern'>
                                <h3 className='info-heading'>{translations[language]?.totalSpaces || 'Total Spaces'}</h3>
                                <p>{selectedlot?.total_spaces || '-'}</p>
                            </div>
                        </div>
                        <div className='info-childern-div'>
                            <div className='inner-information-childern'>
                                <h3 className='info-heading'>{translations[language]?.organization || 'Organization ID'}</h3>
                                <p>{selectedlot?.organization_name || '-'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomModal>

            <CustomModal
                isVisible={editModal}
                onClose={closeEditModal}
                actionText={translations[language]?.updatelotButton || 'Update lot'}
                title={translations[language]?.editlotText || 'Edit Parking lot'}
                onAction={handleUpdatelot}
                loading={editDataLoading}
                language={language}
            >
                <Form form={editlotForm} layout='vertical' className='pl-form'>
                    <div className='ps-section-head pl-form-head'>
                        <h3>{translations[language]?.lotDetailsHeading || 'Parking lot Details'}</h3>
                    </div>
                    <Inputs
                        label={translations[language]?.parkinglotName || 'Parking lot Name'}
                        placeholder={translations[language]?.enterlotName || 'Enter lot name'}
                        name='name'
                        rules={[{ required: true, message: translations[language]?.pleaseEnterParkingLotName || 'Please enter parking lot name' }]}
                    />
                    <Inputs
                        label={translations[language]?.address || 'Address'}
                        placeholder={translations[language]?.enterAddress || 'Enter address'}
                        name='address'
                        rules={[{ required: true, message: translations[language]?.pleaseEnterAddress || 'Please enter address' }]}
                    />
                    <Inputs
                        label={translations[language]?.totalSpaces || 'Total Spaces'}
                        placeholder={translations[language]?.enterTotalSpaces || 'Enter total spaces'}
                        name='totalSpaces'
                        type='number'
                        max={100000}
                        min={1}
                        rules={[
                            { required: true, message: translations[language]?.pleaseEnterTotalSpaces || 'Please enter total number of spaces' },
                            {
                                validator: (_, value) => {
                                    if (value === undefined || value === '') return Promise.resolve();
                                    const num = Number(value);
                                    if (isNaN(num)) return Promise.reject(translations[language]?.pleaseEnterValidNumber || 'Please enter a valid number');
                                    if (num < 1) return Promise.reject(translations[language]?.totalSpacesAtLeast1 || 'Total spaces must be at least 1');
                                    if (num > 100000) return Promise.reject(translations[language]?.totalSpacesMax || 'Total spaces cannot exceed 100000');
                                    if (!Number.isInteger(num)) return Promise.reject(translations[language]?.totalSpacesWholeNumber || 'Total spaces must be a whole number');
                                    return Promise.resolve();
                                }
                            }
                        ]}
                    />
                    <div>
                        <CustomSelect
                            label={translations[language]?.organizations || 'Organization'}
                            placeholder={translations[language]?.organizationSelect || 'Select organization'}
                            name="organization"
                            filterOption={(input, option) =>
                                String(option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={
                                organizationDetails?.id
                                    ? [{ label: organizationDetails?.name, value: organizationDetails?.id }]
                                    : organizations?.map(org => ({
                                        label: org?.organization_name,
                                        value: org?.id
                                    }))
                            }
                            disabled={true}
                            rules={[{ required: true, message: translations[language]?.pleaseSelectOrganization || 'Please select an organization' }]}
                        />
                    </div>
                </Form>
            </CustomModal>

            <div className={`search-organization-main-div ${searchModal ? 'open' : ''}`}>
                <SearchOrganizationsParking
                    searchType={"lots"}
                    selectedOrganizations={organizationFilter}
                    handleOrganizationChange={handleOrganizationChange}
                    organizations={organizations}
                    setSearchModal={setSearchModal}
                    searchModal={searchModal}
                    selectedFilter={userFilterRedux}
                    language={language}
                />
            </div>

            <DeleteModal
                title={translations[language]?.deletelot || 'Delete Parking lot'}
                bodyText={<>{translations[language]?.areYouSureYouWantToDltThislot || 'Are you sure you want to delete this parking lot?'}</>}
                isOpen={deleteModal}
                onCancel={handleCancel}
                onDelete={handleConfirmDelete}
                language={language}
            />
        </div>
    )
}

export default ManageParkinglots